import { CSSProperties } from "react";
import { getStyle } from "@app/shared/icons/utils";
import { IconStorage } from "@app/shared/icons/interfaces";

export const filePdfOutline: IconStorage = {
  svgCode: (color: string, pathStyle?: CSSProperties) => (
    <path
      d="M11.469-9.031q.217.22.375.594c.101.25.156.48.156.687v9a.74.74 0 0 1-.219.531.74.74 0 0 1-.531.219H.75a.72.72 0 0 1-.531-.219A.72.72 0 0 1 0 1.25v-12.5a.72.72 0 0 1 .219-.531A.72.72 0 0 1 .75-12h7c.207 0 .438.055.688.156q.373.158.593.375zM8-10.937V-8h2.938q-.08-.235-.172-.328l-2.438-2.438q-.093-.091-.328-.171M11 1v-8H7.75a.7.7 0 0 1-.531-.219A.7.7 0 0 1 7-7.75V-11H1V1ZM6.984-3.64q.264.203.657.437.466-.047.922-.047c.757 0 1.218.125 1.375.375q.121.174.015.406c0 .012-.008.024-.015.032v.015q-.048.299-.563.297c-.25 0-.555-.05-.906-.156a5 5 0 0 1-1-.422c-1.156.125-2.18.344-3.063.656Q3.201.002 2.516 0a.37.37 0 0 1-.22-.062L2.11-.156q-.017.002-.046-.031-.082-.076-.047-.282.059-.31.422-.718.374-.405 1.046-.75c.07-.051.13-.036.172.046q.014.019.016.032.404-.668.844-1.547c.351-.707.625-1.39.812-2.047a6.7 6.7 0 0 1-.25-1.234q-.048-.61.063-1Q5.216-8 5.469-8h.172c.113 0 .203.04.265.11.094.117.117.292.078.53a.2.2 0 0 1-.03.063V-7q-.018.972-.11 1.5c.289.855.672 1.477 1.14 1.86m-4.5 3.218q.405-.186 1.079-1.234c-.274.21-.5.43-.688.656-.187.23-.32.422-.39.578m3.11-7.187q-.11.328-.016 1.03c.008-.038.031-.155.063-.343q0-.029.047-.344c.007-.02.02-.039.03-.062v-.016q-.015-.014-.015-.015a.42.42 0 0 0-.094-.282l-.015.016zm-.969 5.156a11.3 11.3 0 0 1 2.219-.625q-.017-.013-.11-.078a.4.4 0 0 1-.109-.11q-.596-.513-1-1.375a10.3 10.3 0 0 1-1 2.188m5.047-.125q-.19-.188-1.094-.188.593.222.969.22h.14q-.002-.014-.015-.032m0 0"
      style={getStyle(color, pathStyle)}
      transform="translate(0 12)"
    />
  ),
  svgProps: {
    height: "14",
    width: "12",
  }
};

export const filesOutline: IconStorage = {
  svgCode: (color: string, pathStyle?: CSSProperties) => (
    <path
      d="M13.25-9q.31 0 .531.219A.74.74 0 0 1 14-8.25v9.5a.74.74 0 0 1-.219.531.74.74 0 0 1-.531.219h-7.5a.72.72 0 0 1-.531-.219A.72.72 0 0 1 5 1.25V-1H.75a.7.7 0 0 1-.531-.219A.7.7 0 0 1 0-1.75V-7q-.002-.311.156-.687.153-.373.375-.594L3.72-11.47q.218-.217.594-.375c.25-.101.476-.156.687-.156h3.25q.31 0 .531.219A.74.74 0 0 1 9-11.25v2.563C9.352-8.895 9.688-9 10-9zM9-7.344 6.672-5H9zm-5-3L1.672-8H4zM5.531-5.28 8-7.75V-11H5v3.25q0 .316-.219.531A.72.72 0 0 1 4.25-7H1v5h4v-2q-.002-.311.156-.687.153-.373.375-.594M13 1v-9h-3v3.25q0 .316-.219.531A.72.72 0 0 1 9.25-4H6v5zm0 0"
      style={getStyle(color, pathStyle)}
      transform="translate(0 12)"
    />
  ),
  svgProps: {
    height: "14",
    width: "14",
  }
};

export const fileZipOutline: IconStorage = {
  svgCode: (color: string, pathStyle?: CSSProperties) => (
    <path
      d="M5-9v-1H4v1zm1 1v-1H5v1zM5-7v-1H4v1zm1 1v-1H5v1zm5.469-3.031q.217.22.375.594c.101.25.156.48.156.687v9a.74.74 0 0 1-.219.531.74.74 0 0 1-.531.219H.75a.72.72 0 0 1-.531-.219A.72.72 0 0 1 0 1.25v-12.5a.72.72 0 0 1 .219-.531A.72.72 0 0 1 .75-12h7c.207 0 .438.055.688.156q.373.158.593.375zM8-10.937V-8h2.938q-.08-.235-.172-.328l-2.438-2.438q-.093-.091-.328-.171M11 1v-8H7.75a.7.7 0 0 1-.531-.219A.7.7 0 0 1 7-7.75V-11H6v1H5v-1H1V1ZM6.11-4.64l.828 2.734q.06.205.062.406 0 .646-.562 1.078Q5.874 0 5 0q-.862 0-1.437-.422Q3-.855 3-1.5q0-.2.063-.406Q3.233-2.404 4-5v-1h1v1h.625c.113 0 .211.04.297.11a.46.46 0 0 1 .187.25m-1.813 3.5Q4.59-1 5-1q.422 0 .703-.14C5.898-1.243 6-1.364 6-1.5c0-.133-.102-.25-.297-.344A1.46 1.46 0 0 0 5-2c-.273 0-.508.055-.703.156Q3.998-1.7 4-1.5q0 .206.297.36m0 0"
      style={getStyle(color, pathStyle)}
      transform="translate(0 12)"
    />
  ),
  svgProps: {
    height: "14",
    width: "12",
  }
};
